/**
 * 日本語翻訳
 * Japanese Translation
 */

const jaJPTranslations = {
  app: {
    title: '残業管理ツール',
    subtitle: '残業管理システム',
    description: 'プロフェッショナルな残業記録と代休管理ツール'
  },

  // 日時関連
  dateTime: {
    invalidDate: '無効な日付',
    formatError: '日付形式エラー'
  },

  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    copy: 'コピー',
    close: '閉じる',
    loading: '読み込み中...',
    success: '成功',
    error: 'エラー',
    warning: '警告',
    info: '情報',
    yes: 'はい',
    no: 'いいえ',
    ok: 'OK',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    reset: 'リセット',
    clear: 'クリア',
    search: '検索',
    filter: 'フィルター',
    sort: 'ソート',
    export: 'エクスポート',
    import: 'インポート',
    settings: '設定',
    help: 'ヘルプ',
    about: 'について'
  },
  
  time: {
    startTime: '開始時間',
    endTime: '終了時間',
    duration: '時間',
    totalTime: '合計時間',
    remainingTime: '残り時間',
    usedTime: '使用時間',
    availableTime: '利用可能時間',
    hours: '時間',
    minutes: '分',
    days: '日',
    today: '今日',
    yesterday: '昨日',
    thisWeek: '今週',
    thisMonth: '今月',
    thisYear: '今年'
  },
  
  overtime: {
    title: '残業記録',
    record: '残業を記録',
    startTime: '残業開始時間',
    endTime: '残業終了時間',
    duration: '残業時間',
    remaining: '残り代休時間',
    total: '総残業時間',
    list: '残業記録リスト',
    details: '詳細記録',
    consumption: '消費記録',
    edit: '残業記録を編集',
    delete: '残業記録を削除',
    copy: '記録をコピー',
    
    validation: {
      startTimeRequired: '残業開始時間を入力してください！',
      endTimeRequired: '残業終了時間を入力してください！',
      endTimeAfterStart: '残業終了時間は開始時間より後である必要があります！'
    },
    
    stats: {
      totalHours: '今年度は{{hours}}時間の残業をしました',
      remainingHours: '残り代休時間：{{overtimeHours}}+{{annualLeaveHours}}時間'
    }
  },
  
  rest: {
    title: '代休記録',
    record: '代休を申請',
    startTime: '代休開始時間',
    endTime: '代休終了時間',
    duration: '代休時間',
    type: '代休タイプ',
    compTime: '代休',
    list: '代休記録リスト',
    edit: '代休記録を編集',
    delete: '代休記録を削除',
    
    validation: {
      startTimeRequired: '代休開始時間と終了時間を入力してください！',
      endTimeRequired: '代休終了時間を入力してください！',
      endTimeAfterStart: '代休終了時間は開始時間より後である必要があります！',
      insufficientTime: 'この代休申請には残り時間が不足しています！',
      insufficientOvertimeTime: '代休時間を増やすには残業時間が不足しています！'
    }
  },
  
  annualLeave: {
    title: '年次有給休暇管理',
    totalDays: '年次有給休暇総日数',
    usedHours: '使用時間',
    remainingHours: '残り時間',
    record: '年次有給休暇記録',
    set: '年次有給休暇を設定',
    edit: '年次有給休暇記録を編集',
    delete: '年次有給休暇記録を削除',
    
    settings: {
      title: '年次有給休暇を設定',
      totalDaysLabel: '年次有給休暇総日数',
      totalDaysPlaceholder: '年次有給休暇総日数を入力',
      note: '注意：年次有給休暇は1日8時間で計算されます'
    }
  },
  
  rules: {
    title: '計算ルール',
    overtime: {
      title: '残業計算ルール',
      description: '連続時間で計算、昼休みを含む',
      example: '例：{{timeRange}} = {{result}}',
      note: '残業時間は実際の連続時間で計算、昼休みは差し引かれません'
    },
    rest: {
      title: '代休計算ルール',
      description: '営業日で計算、昼休みを差し引く',
      example: '例：{{timeRange}} = {{result}}（{{note}}）',
      note: '1時間の昼休みを差し引く',
      workingHours: '勤務時間：9:00-18:00（12:00-13:00の昼休みを除く）'
    },
    annualLeave: {
      title: '年次有給休暇計算ルール',
      description: '年次有給休暇は1日8時間で計算',
      example: '年次有給休暇1日 = 8時間'
    }
  },
  
  data: {
    save: 'データをローカルに保存',
    load: 'バックアップデータを読み込み',
    export: 'データをエクスポート',
    import: 'データをインポート',
    backup: 'データをバックアップ',
    restore: 'データを復元',
    clear: 'データをクリア',
    
    messages: {
      saveSuccess: 'データが正常に保存されました',
      loadSuccess: 'データが正常にインポートされ、更新されました',
      exportSuccess: 'データが正常にエクスポートされました',
      importSuccess: 'データが正常にインポートされました',
      clearSuccess: 'データが正常にクリアされました',
      parseError: 'インポートファイルを解析できません。有効な形式であることを確認してください。',
      newerDataWarning: 'インポートされたデータはローカルデータより古いです。それでもローカルデータを上書きしますか？',
      cleanupComplete: 'クリーンアップが完了しました。{{count}}件の冗長レコードが削除されました。'
    }
  },
  
  table: {
    index: 'インデックス',
    number: '番号',
    type: 'タイプ',
    startTime: '開始時間',
    endTime: '終了時間',
    duration: '時間',
    remaining: '残り時間',
    remainingTime: '残り代休可能時間',
    actions: 'アクション',
    details: '詳細記録',
    expand: '展開',
    collapse: '折りたたみ',
    noData: 'データなし',
    consumptionRecords: '消費記録',
    restRequestStartTime: '休暇申請開始時間',
    restRequestEndTime: '休暇申請終了時間',
    actualConsumptionStartTime: '実際消費開始時間',
    actualConsumptionEndTime: '実際消費終了時間',
    deductionTime: '控除時間',
    annualLeaveStartTime: '年次休暇開始時間',
    annualLeaveEndTime: '年次休暇終了時間',

    pagination: {
      total: '合計{{total}}件',
      pageSize: 'ページあたりの項目数',
      items: '項目',
      page: 'ページ'
    }
  },

  // 記録関連
  records: {
    overtimeRecords: '残業記録',
    restRecords: '代休記録',
    annualLeaveRecords: '年次休暇記録',
    restType: '代休',
    annualLeaveType: '年次休暇',
    annualLeave: '年次休暇',
    rest: '代休',
    overtime: '残業'
  },

  // ページング関連
  pagination: {
    previous: '前のページ',
    next: '次のページ',
    pageInfo: '第{{current}}ページ、全{{total}}ページ',
    itemsPerPage: '{{count}}件/ページ'
  },

  // コピー機能
  copy: {
    deductOvertimeTotal: '残業代休、対応する残業時間を控除（{{hours}}時間）',
    deductAnnualLeaveTotal: '年次休暇時間を控除（{{hours}}時間）',
    annualLeaveTitle: '年次休暇:',
    errorPrefix: 'テキストをコピーできません: '
  },

  // 統計情報
  stats: {
    totalOvertime: '累計社畜時間',
    availableOvertime: '利用可能社畜時間',
    remainingAnnualLeave: '残り大休暇時間',
    totalRest: '取得済みサボり時間'
  },

  // 操作ボタン
  actions: {
    recordOvertime: '社畜イベント記録',
    addOvertimeTime: '社畜記録を追加',
    requestRest: 'サボり申請',
    useOvertimeTime: 'サボり開始~~',
    setAnnualLeave: '大休暇時間設定',
    configureAnnualLeaveDays: '年度大休暇時間を設定',
    recordAnnualLeave: '大休暇時間記録',
    saveData: '社畜記録保存',
    exportData: '社畜記録エクスポート',
    importData: '社畜記録インポート',
    cleanData: '重複社畜記録クリーンアップ'
  },

  // メッセージ
  messages: {
    overtimeAdded: '社畜記録が追加されました',
    restAdded: 'サボり記録が追加されました',
    overtimeDeleted: '社畜記録が削除されました',
    restDeleted: 'サボり記録が削除されました',
    dataSaved: 'データが保存されました',
    dataLoaded: 'データが読み込まれました',
    dataImported: 'データがインポートされました',
    dataExported: 'データがエクスポートされました',
    noLocalData: 'ローカルデータが見つかりません、デフォルトデータを使用します',
    cleanupComplete: 'クリーンアップ完了、{{count}}件の冗長記録を削除しました',
    overtimeRecordAdded: '社畜記録の追加が成功しました！',
    restRequestSubmitted: 'サボり申請が提出されました！',
    pleaseCompleteTimeInfo: '時間情報を完全に入力してください',
    overtimeRecordUpdated: '社畜記録の更新が成功しました！',
    restRecordUpdated: 'サボり記録の更新が成功しました！',
    annualLeaveRecordUpdated: '大休暇時間記録の更新が成功しました！',
    annualLeaveRecordAdded: '大休暇時間記録の追加が成功しました！',
    copiedToClipboard: 'クリップボードにコピーされました',
    copyFailed: 'コピーに失敗しました、再試行してください'
  },

  // モーダル
  modals: {
    recordOvertimeTitle: '社畜イベント記録',
    requestRestTitle: 'サボり申請表',
    setAnnualLeaveTitle: '🏖️ 大休暇時間設定',
    recordOvertimeTimeTitle: '⏱️ 社畜時間記録',
    requestRestTimeTitle: '😴 サボり時間申請',
    editOvertimeTitle: '社畜記録編集',
    editRestTitle: 'サボり記録編集',
    editAnnualLeaveTitle: '大休暇時間記録編集',
    recordAnnualLeaveTitle: '🏖️ 大休暇時間記録',
    editRecordTitle: '記録編集'
  },

  // フォーム
  forms: {
    currentAnnualLeave: '現在の大休暇時間：',
    remainingTime: '残り大時間：',
    noAnnualLeave: '大休暇時間なし',
    customDays: 'カスタム大時間：',
    enterDays: '大時間を入力',
    description: '備考：',
    descriptionPlaceholder: 'オプションの備考情報',
    annualLeaveStartTime: '大時間開始時間:',
    annualLeaveEndTime: '大時間終了時間:',
    overtimeStartTime: '社畜開始時間:',
    overtimeEndTime: '社畜終了時間:'
  },

  // 確認ダイアログ
  confirmDialog: {
    deleteMessage: 'この記録を削除してもよろしいですか？',
    cleanupMessage: '冗長データをクリーンアップしてもよろしいですか？この操作は元に戻せません。',
    deleteRestMessage: 'このサボり記録を削除してもよろしいですか？',
    deleteAnnualLeaveMessage: 'この年次休暇記録を削除してもよろしいですか？'
  },


  
  consumption: {
    title: '代休消費記録',
    restStartTime: '代休申請開始時間',
    restEndTime: '代休申請終了時間',
    actualStartTime: '実際の消費開始時間',
    actualEndTime: '実際の消費終了時間',
    deductionTime: '代休控除時間',
    type: 'タイプ',
    
    copyReport: {
      overtimeDeduction: '対応する社畜時間を控除（{{hours}}時間）',
      annualLeaveDeduction: '大休暇時間を控除（{{hours}}時間）',
      copySuccess: 'クリップボードにコピーしました',
      copyFailed: 'コピーに失敗しました。もう一度お試しください'
    }
  },
  
  updateLog: {
    title: '更新ログ',
    show: '更新ログを表示',
    hide: '更新ログを非表示',
    version: 'バージョン',
    date: '日付',
    content: '更新内容'
  },

  
  errors: {
    networkError: 'ネットワークエラー、接続を確認してください',
    serverError: 'サーバーエラー、後でもう一度お試しください',
    unknownError: '不明なエラー、管理者にお問い合わせください',
    validationError: 'データ検証に失敗しました',
    permissionDenied: '権限が拒否されました',
    notFound: 'データが見つかりません',
    timeout: 'リクエストタイムアウト、もう一度お試しください'
  },

  // テーマ関連
  theme: {
    toggle: 'テーマ切り替え',
    modern: 'モダンスタイル',
    retro: 'レトロスタイル',
    sketch: '手描きスタイル',
    damaged: '戦損スタイル',
    switchToModern: 'モダンスタイルに切り替え',
    switchToRetro: 'レトロスタイルに切り替え',
    switchToSketch: '手描きスタイルに切り替え',
    switchToDamaged: '戦損スタイルに切り替え'
  }
};

export default jaJPTranslations;
